import { getReviveItems } from 'services/apis/revive-experiences-api';
import { GET_REVIVE_ITEMS } from 'constants/revive';

export const getReviveAction = (max) => ({
  type: GET_REVIVE_ITEMS,
  payload: getReviveItems(max),
});
